<template>
  <div class="flex items-start">
    <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 mr-2 flex-shrink-0" :class="bulletColor" fill="none"
         viewBox="0 0 24 24"
         stroke="currentColor">
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
            d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"/>
    </svg>
    <p class="text-left">
      <slot></slot>
    </p>
  </div>
</template>

<script>
export default {
  name: 'bullet-point',
  props: ['bulletColor']
}
</script>
